import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZigbeeComponent } from './simple-icons-zigbee.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZigbeeComponent ],
    exports:      [ SimpleIconsZigbeeComponent ],
    bootstrap:    []
})
export class SimpleIconsZigbeeModule {}
